// Wordpress components
import { addFilter, removeFilter } from '@wordpress/hooks';
import { Notice } from '@wordpress/components';
import { _n, __ } from '@wordpress/i18n';

// Wp Travel components.
import ExcludedDates from './trip-excluded-dates';
import RecurringDates from './RecurringDates';
import CutoffTime from './CutoffTime';

// Exclude dates.
addFilter(
    'wp_travel_itinerary_price_tab_table_last_row',
    'wp_travel',
    (content, allData) => {
        const {is_fixed_departure} = allData
        // content.splice(0, 1)
        return is_fixed_departure ? [...content,  <ExcludedDates key="excludeDates" />] : content
    },
    15
);

// Enable recurring dates
addFilter(
    'wp_travel_after_end_date',
    'wp_travel',
    (content, ...params) => {
        return [
            ...content,
            <RecurringDates dates={params[0]} _dateIndex={params[1]} _date={params[2]} onUpdate={params[3]} storeKey={params[4]} />
        ]
    }
);

removeFilter( 'wp_travel_admin_map_area', 'WPTravel/TripEdit/Locations/MapNotice' );
removeFilter( 'wptravel_trip_edit_block_map_area', 'WPTravel/TripEdit/Block/Maps/MapsNoticeFields' );

// Removed Addons notice. 
addFilter(
    'wp_travel_addons_setings_tab_fields',
    'wp_travel',
    (content) => {
        content.splice(0, 1)
        return content
    },
    15
);

// Removed Payment tab notice. 
addFilter(
    'wp_travel_after_payment_fields',
    'wp_travel',
    (content) => {
        content.splice(0, 1)
        return content
    },
    15
);

// Removed License tab notice. 
addFilter(
    'wp_travel_license_tab_fields',
    'wp_travel',
    (content) => {
        content.splice(0, 1)
        return content
    },
    15
);

// Removed Map upsell. 
addFilter(
    'wp_travel_settings_after_maps_upsell',
    'wp_travel',
    (content) => {
        content.splice(0, 1)
        return content
    },
    15
);

addFilter('wp_travel_before_dates_options', 'wp-travel', (content) => {
    return [
        ...content,
        <CutoffTime  />
    ]
}, 9 );

const DisabledNotice = ( {addon, hasTitle, message, forceOverride } ) => {
    let addonName       = addon ? addon : 'WP Travel Module';
    let addonHasTitle   = hasTitle ?  hasTitle : false;

    let addonMessage    = addonName + __( ' is currently disabled please go to Modules Settings to enable it and reload the page. ' );
    if ( message ) {
        if ( ! forceOverride ) {
            addonMessage   += message;
        } else {
            addonMessage   = message;
        }
    }
    return <>
    { addonHasTitle && <h3>{addonName}</h3> }
    <Notice isDismissible={false} status="warning">
        <p dangerouslySetInnerHTML={ { __html: addonMessage } }></p>
    </Notice><br/></>
}

// DisabledNotice without title
const DisabledNoticeLite = ( {addon, message, forceOverride } ) => {
    let addonName       = addon ? addon : 'WP Travel Module';

    let addonMessage    = addonName + __( ' is currently disabled please go to Modules Settings to enable it and reload the page. ' );
    if ( message ) {
        if ( ! forceOverride ) {
            addonMessage   += message;
        } else {
            addonMessage   = message;
        }
    }
    return <>
        <Notice isDismissible={false} status="warning">
            <p dangerouslySetInnerHTML={ { __html: addonMessage } }></p>
        </Notice><br/>
    </>
}

// New code Settings Notices.
// Utilities.
addFilter( 'wp_travel_tab_content_before_trips', 'WPTravel/Settings/Trip/NoticeDisabled', ( content, settings ) => {
    const {modules, options} = settings;
    const { default_settings } = options;
    const { modules:defaultModules } = default_settings;
    const moduleSettings = 'undefined' !== typeof modules && Object.keys( modules ).length > 0 ? modules : defaultModules;
    const isActive  = 'undefined' !== typeof moduleSettings.show_wp_travel_utilities && 'yes' === moduleSettings.show_wp_travel_utilities.value;
    if ( ! content ) { content = []; } // Fixes for legacy support. 
    if ( ! isActive ) { content = [ ...content, <DisabledNotice addon="Utilities" message={__( 'This will enable custom trip code.' )} /> ]; }
    return content;
}
);

removeFilter( 'wp_travel_tab_content_before_email', 'WPTravel/Settings/Email/Notice' );
addFilter( 'wp_travel_tab_content_before_email', 'WPTravel/Settings/Email/NoticeDisabled', ( content, settings ) => {
    const {modules, options} = settings;
    const { default_settings } = options;
    const { modules:defaultModules } = default_settings;
    const moduleSettings = 'undefined' !== typeof modules && Object.keys( modules ).length > 0 ? modules : defaultModules;
    const isActive  = 'undefined' !== typeof moduleSettings.show_wp_travel_utilities && 'yes' === moduleSettings.show_wp_travel_utilities.value;
    if ( ! content ) { content = []; } // Fixes for legacy support. 
    if ( ! isActive ) { content = [ ...content, <DisabledNotice addon="Utilities" message={__( 'This will enable more email features.' )} /> ]; }
    return content;
});

removeFilter('wp_travel_custom_global_tabs', 'WPTravel/Settings/Tabs/Notice' );
addFilter('wp_travel_custom_global_tabs', 'WPTravel/Settings/Tabs/NoticeDisabled', ( content, settings ) => {
    const {modules, options} = settings;
    const { default_settings } = options;
    const { modules:defaultModules } = default_settings;
    const moduleSettings = 'undefined' !== typeof modules && Object.keys( modules ).length > 0 ? modules : defaultModules;
    const isActive  = 'undefined' !== typeof moduleSettings.show_wp_travel_utilities && 'yes' === moduleSettings.show_wp_travel_utilities.value;
    if ( ! content ) { content = []; } // Fixes for legacy support. 
    if ( ! isActive ) { content = [ ...content, <DisabledNotice addon="Utilities" message={__( 'This will enable custom tabs.' )} /> ]; }
    return content;
} );

removeFilter('wp_travel_settings_tab_faq_fields', 'WPTravel/Settings/Faqs/Notice' );
addFilter('wp_travel_settings_tab_faq_fields', 'WPTravel/Settings/Faqs/NoticeDisabled', ( content, settings ) => {
    const {modules, options} = settings;
    const { default_settings } = options;
    const { modules:defaultModules } = default_settings;
    const moduleSettings = 'undefined' !== typeof modules && Object.keys( modules ).length > 0 ? modules : defaultModules;
    const isActive  = 'undefined' !== typeof moduleSettings.show_wp_travel_utilities && 'yes' === moduleSettings.show_wp_travel_utilities.value;
    if ( ! content ) { content = []; } // Fixes for legacy support. 
    if ( ! isActive ) { content = [ ...content, <DisabledNotice addon="Utilities" /> ]; }
    return content;
} );

removeFilter('wp_travel_settings_tab_cart_checkout_fields', 'WPTravel/Settings/Checkout/Notice' );
addFilter('wp_travel_settings_tab_cart_checkout_fields', 'WPTravel/Settings/Checkout/NoticeDisabled', ( content, settings ) => {
    const {modules, options} = settings;
    const { default_settings } = options;
    const { modules:defaultModules } = default_settings;
    const moduleSettings = 'undefined' !== typeof modules && Object.keys( modules ).length > 0 ? modules : defaultModules;
    const isActive  = 'undefined' !== typeof moduleSettings.show_wp_travel_utilities && 'yes' === moduleSettings.show_wp_travel_utilities.value;
    if ( ! content ) { content = []; } // Fixes for legacy support. 
    if ( ! isActive ) { content = [ ...content, <DisabledNotice addon="Utilities" /> ]; }
    return content;
} );

addFilter('wp_travel_after_payment_fields', 'WPTravel/Settings/Payment/NoticeDisabled', ( content, settings ) => {
    if ( ! content ) { content = []; } // Fixes for legacy support. 
    content = [ ...content, <DisabledNotice message={_wp_travel.setting_strings.payment.paystack_note} forceOverride={true} /> ];
    return content;
} );

// Utilities trip edit/ Trip Code
removeFilter( 'wptravel_trip_edit_trip_code_notice', 'WPTravel/TripEdit/TripCodeNotice' );
addFilter('wptravel_trip_edit_trip_code_notice', 'WPTravel/TripEdit/TripCodeNoticeDisabled', ( content, settings ) => {
    const {modules, options} = settings;
    const { default_settings } = options;
    const { modules:defaultModules } = default_settings;
    const moduleSettings = 'undefined' !== typeof modules && Object.keys( modules ).length > 0 ? modules : defaultModules;
    const isActive  = 'undefined' !== typeof moduleSettings.show_wp_travel_utilities && 'yes' === moduleSettings.show_wp_travel_utilities.value;
    if ( ! content ) { content = []; } // Fixes for legacy support. 
    if ( ! isActive ) { content = [ ...content, <DisabledNotice addon="Utilities" /> ]; }
    return content;
} );

// Utilities trip edit / extras.
removeFilter("wp_travel_trip_extras_notice", "WPTravel/TripEdit/TripExtrasNotice" );
addFilter('wp_travel_trip_extras_notice', 'WPTravel/TripEdit/TripExtrasNoticeDisabled', ( content, settings ) => {
    const {modules, options} = settings;
    const { default_settings } = options;
    const { modules:defaultModules } = default_settings;
    const moduleSettings = 'undefined' !== typeof modules && Object.keys( modules ).length > 0 ? modules : defaultModules;
    const isActive  = 'undefined' !== typeof moduleSettings.show_wp_travel_utilities && 'yes' === moduleSettings.show_wp_travel_utilities.value;
    if ( ! content ) { content = []; } // Fixes for legacy support. 
    if ( ! isActive ) { content = [ ...content, <DisabledNotice addon="Utilities" /> ]; }
    return content;
} );

// Field Editor.
removeFilter( 'wp_travel_settings_tab_field_editor_fields', 'WPTravel/Settings/FieldEditor/Notice' );
addFilter( 'wp_travel_settings_tab_field_editor_fields', 'WPTravel/Settings/FieldEditor/NoticeDisabled', ( content, settings ) => {
    const {modules, options} = settings;
    const { default_settings } = options;
    const { modules:defaultModules } = default_settings;
    const moduleSettings = 'undefined' !== typeof modules && Object.keys( modules ).length > 0 ? modules : defaultModules;
    const isActive  = 'undefined' !== typeof moduleSettings.show_wp_travel_field_editor && 'yes' === moduleSettings.show_wp_travel_field_editor.value;
    if ( ! content ) { content = []; } // Fixes for legacy support. 
    if ( ! isActive ) { content = [ ...content, <DisabledNotice addon="Field Editor" /> ]; }
    return content;
} );

// Invoice.
removeFilter( 'wp_travel_settings_tab_invoice_fields', 'WPTravel/Settings/Invoice/Notice' );
addFilter( 'wp_travel_settings_tab_invoice_fields', 'WPTravel/Settings/Invoice/NoticeDisabled', ( content, settings ) => {
    const {modules, options} = settings;
    const { default_settings } = options;
    const { modules:defaultModules } = default_settings;
    const moduleSettings = 'undefined' !== typeof modules && Object.keys( modules ).length > 0 ? modules : defaultModules;
    const isActive  = 'undefined' !== typeof moduleSettings.show_wp_travel_invoice && 'yes' === moduleSettings.show_wp_travel_invoice.value;
    if ( ! content ) { content = []; } // Fixes for legacy support. 
    if ( ! isActive ) { content = [ ...content, <DisabledNotice addon="Invoice" /> ]; }
    return content;
} );

// Misc :
addFilter( 'wp_travel_settings_tab_misc_options_fields', 'WPTravel/Settings/Misc/AdvancedGallery/NoticeDisabled', ( content, settings ) => {
    const {modules, options} = settings;
    const { default_settings } = options;
    const { modules:defaultModules } = default_settings;
    const moduleSettings = 'undefined' !== typeof modules && Object.keys( modules ).length > 0 ? modules : defaultModules;
    
    // 
    const isActiveFieldEditor      = 'undefined' !== typeof moduleSettings.show_wp_travel_field_editor && 'yes' === moduleSettings.show_wp_travel_field_editor.value;
    const isActiveAdvancedGallery  = 'undefined' !== typeof moduleSettings.show_wp_travel_advanced_gallery && 'yes' === moduleSettings.show_wp_travel_advanced_gallery.value;
    const isActiveCurrencyExchange = 'undefined' !== typeof moduleSettings.show_wp_travel_currency_exchange_rates && 'yes' === moduleSettings.show_wp_travel_currency_exchange_rates.value;
    const isActiveMailChimp        = 'undefined' !== typeof moduleSettings.show_wp_travel_mailchimp && 'yes' === moduleSettings.show_wp_travel_mailchimp.value;
    const isActiveMultipleCurrency = 'undefined' !== typeof moduleSettings.show_wp_travel_multiple_currency && 'yes' === moduleSettings.show_wp_travel_multiple_currency.value;
    const isActiveWsihlists        = 'undefined' !== typeof moduleSettings.show_wp_travel_wishlists && 'yes' === moduleSettings.show_wp_travel_wishlists.value;
    const isActiveGoogleCalendar   = 'undefined' !== typeof moduleSettings.show_wp_travel_google_calendar && 'yes' === moduleSettings.show_wp_travel_google_calendar.value;
    const isActiveZapier           = 'undefined' !== typeof moduleSettings.show_wp_travel_zapier && 'yes' === moduleSettings.show_wp_travel_zapier.value;
    const isActiveWeatherForcast   = 'undefined' !== typeof moduleSettings.show_wp_travel_trip_weather_forecast && 'yes' === moduleSettings.show_wp_travel_trip_weather_forecast.value;
    
    
    if ( ! content ) { content = []; } // Fixes for legacy support. 

    if ( ! isActiveFieldEditor ) { content = [ ...content, <DisabledNotice addon="reCAPTCHA (V2 Checkbox)" hasTitle={true} message={__( '<br /><b>Note:</b> Please enable Field Editor' )} /> ]; }
    // Advanced Gallery
    if ( ! isActiveAdvancedGallery ) { content = [ ...content, <DisabledNotice addon="Advanced Gallery" hasTitle={true} /> ]; }
    // Currency Exchange.
    if ( ! isActiveCurrencyExchange ) { content = [ ...content, <DisabledNotice addon="Fixer API" hasTitle={true} message={__( '<br /><b>Note:</b> Please enable Currency Exchange Rate' )} /> ]; }
    if ( ! isActiveCurrencyExchange ) { content = [ ...content, <DisabledNotice addon="Currency Exchange Rate" hasTitle={true} /> ]; }
    if ( ! isActiveMailChimp ) { content = [ ...content, <DisabledNotice addon="Mailchimp settings" hasTitle={true} /> ]; }
    if ( ! isActiveMultipleCurrency ) { content = [ ...content, <DisabledNotice addon="Multiple Currency" hasTitle={true} /> ]; }
    if ( ! isActiveWsihlists ) { content = [ ...content, <DisabledNotice addon="Wishlists Options" hasTitle={true} /> ]; }
    if ( ! isActiveGoogleCalendar ) { content = [ ...content, <DisabledNotice addon="Google Calendar" hasTitle={true} /> ]; }
    if ( ! isActiveZapier ) { content = [ ...content, <DisabledNotice addon="Zapier Automation" hasTitle={true} /> ]; }
    if ( ! isActiveWeatherForcast ) { content = [ ...content, <DisabledNotice addon="Weather Forcast API" hasTitle={true} /> ]; }
    return content;
} );

// Advanced Gallery Disabled Notice :
removeFilter('wp_travel_settings_tab_misc_advanced_gallery', 'WPTravel/Settings/Misc/Notices');
addFilter( 'wp_travel_settings_tab_misc_advanced_gallery', 'WPTravel/Settings/Misc/AdvancedGallery/NoticeDisabled', ( content, settings ) => {
    const {modules, options} = settings;
    const { default_settings } = options;
    const { modules:defaultModules } = default_settings;
    const moduleSettings = 'undefined' !== typeof modules && Object.keys( modules ).length > 0 ? modules : defaultModules;
    
    // 
    const isActiveAdvancedGallery  = 'undefined' !== typeof moduleSettings.show_wp_travel_advanced_gallery && 'yes' === moduleSettings.show_wp_travel_advanced_gallery.value;    
    
    if ( ! content ) { content = []; } // Fixes for legacy support. 

    // Advanced Gallery
    if ( ! isActiveAdvancedGallery ) { content = [ ...content, <DisabledNoticeLite addon="Advanced Gallery" hasTitle={true} /> ]; }
    return content;
} );

// ReCaptcha V2 Checkbox Disabled Notice :
removeFilter('wp_travel_settings_tab_misc_recaptcha_v2', 'WPTravel/Settings/Misc/Notices');
addFilter( 'wp_travel_settings_tab_misc_recaptcha_v2', 'WPTravel/Settings/Misc/ReCaptchaV2/NoticeDisabled', ( content, settings ) => {
    const {modules, options} = settings;
    const { default_settings } = options;
    const { modules:defaultModules } = default_settings;
    const moduleSettings = 'undefined' !== typeof modules && Object.keys( modules ).length > 0 ? modules : defaultModules;
    
    // 
    const isActiveFieldEditor      = 'undefined' !== typeof moduleSettings.show_wp_travel_field_editor && 'yes' === moduleSettings.show_wp_travel_field_editor.value;
    
    if ( ! content ) { content = []; } // Fixes for legacy support. 

    // Advanced Gallery
    if ( ! isActiveFieldEditor ) { content = [ ...content, <DisabledNoticeLite addon="reCAPTCHA (V2 Checkbox)" hasTitle={true} message={__( '<br /><b>Note:</b> Please enable Field Editor' )} /> ]; }
    return content;
} );

// Currency Exchange Disabled Notice :
removeFilter('wp_travel_settings_tab_misc_currency_exchange', 'WPTravel/Settings/Misc/Notices');
addFilter( 'wp_travel_settings_tab_misc_currency_exchange', 'WPTravel/Settings/Misc/ThirdParty/NoticeDisabled', ( content, settings ) => {
    const {modules, options} = settings;
    const { default_settings } = options;
    const { modules:defaultModules } = default_settings;
    const moduleSettings = 'undefined' !== typeof modules && Object.keys( modules ).length > 0 ? modules : defaultModules;
    
    // 
    const isActiveCurrencyExchange = 'undefined' !== typeof moduleSettings.show_wp_travel_currency_exchange_rates && 'yes' === moduleSettings.show_wp_travel_currency_exchange_rates.value;
    
    if ( ! content ) { content = []; } // Fixes for legacy support. 

    // Currency Exchange.
    if ( ! isActiveCurrencyExchange ) { content = [ ...content, <DisabledNotice addon="Fixer API" hasTitle={true} message={__( '<br /><b>Note:</b> Please enable Currency Exchange Rate' )} /> ]; }
    if ( ! isActiveCurrencyExchange ) { content = [ ...content, <DisabledNotice addon="Currency Exchange Rate" hasTitle={true} /> ]; }
    return content;
} );

// Google Calendar Disabled Notice :
removeFilter('wp_travel_settings_tab_misc_google_calendar', 'WPTravel/Settings/Misc/Notices');
addFilter( 'wp_travel_settings_tab_misc_google_calendar', 'WPTravel/Settings/Misc/ThirdParty/NoticeDisabled', ( content, settings ) => {
    const {modules, options} = settings;
    const { default_settings } = options;
    const { modules:defaultModules } = default_settings;
    const moduleSettings = 'undefined' !== typeof modules && Object.keys( modules ).length > 0 ? modules : defaultModules;
    
    // 
    const isActiveGoogleCalendar   = 'undefined' !== typeof moduleSettings.show_wp_travel_google_calendar && 'yes' === moduleSettings.show_wp_travel_google_calendar.value;
    
    
    if ( ! content ) { content = []; } // Fixes for legacy support. 

    if ( ! isActiveGoogleCalendar ) { content = [ ...content, <DisabledNotice addon="Google Calendar" hasTitle={true} /> ]; }
    return content;
} );

// Weather Forecast API Disabled Notice :
removeFilter('wp_travel_settings_tab_misc_trip_weather_forecast', 'WPTravel/Settings/Misc/Notices');
addFilter( 'wp_travel_settings_tab_misc_trip_weather_forecast', 'WPTravel/Settings/Misc/ThirdParty/NoticeDisabled', ( content, settings ) => {
    const {modules, options} = settings;
    const { default_settings } = options;
    const { modules:defaultModules } = default_settings;
    const moduleSettings = 'undefined' !== typeof modules && Object.keys( modules ).length > 0 ? modules : defaultModules;
    
    // 
    const isActiveWeatherForcast   = 'undefined' !== typeof moduleSettings.show_wp_travel_trip_weather_forecast && 'yes' === moduleSettings.show_wp_travel_trip_weather_forecast.value;
    
    
    if ( ! content ) { content = []; } // Fixes for legacy support. 

    if ( ! isActiveWeatherForcast ) { content = [ ...content, <DisabledNotice addon="Weather Forcast API" hasTitle={true} /> ]; }
    return content;
} );

// Wishlists Disabled Notice :
removeFilter('wp_travel_settings_tab_misc_wishlists', 'WPTravel/Settings/Misc/Notices');
addFilter( 'wp_travel_settings_tab_misc_wishlists', 'WPTravel/Settings/Misc/ThirdParty/NoticeDisabled', ( content, settings ) => {
    const {modules, options} = settings;
    const { default_settings } = options;
    const { modules:defaultModules } = default_settings;
    const moduleSettings = 'undefined' !== typeof modules && Object.keys( modules ).length > 0 ? modules : defaultModules;
    
    // 
    const isActiveWsihlists        = 'undefined' !== typeof moduleSettings.show_wp_travel_wishlists && 'yes' === moduleSettings.show_wp_travel_wishlists.value;    
    
    if ( ! content ) { content = []; } // Fixes for legacy support. 

    if ( ! isActiveWsihlists ) { content = [ ...content, <DisabledNotice addon="Wishlists Options" hasTitle={true} /> ]; }
    return content;
} );

// Zapier Automation Disabled Notice :
removeFilter('wp_travel_settings_tab_misc_zapier', 'WPTravel/Settings/Misc/Notices');
addFilter( 'wp_travel_settings_tab_misc_zapier', 'WPTravel/Settings/Misc/ThirdParty/NoticeDisabled', ( content, settings ) => {
    const {modules, options} = settings;
    const { default_settings } = options;
    const { modules:defaultModules } = default_settings;
    const moduleSettings = 'undefined' !== typeof modules && Object.keys( modules ).length > 0 ? modules : defaultModules;
    
    // 
    const isActiveZapier           = 'undefined' !== typeof moduleSettings.show_wp_travel_zapier && 'yes' === moduleSettings.show_wp_travel_zapier.value;    
    
    if ( ! content ) { content = []; } // Fixes for legacy support. 

    if ( ! isActiveZapier ) { content = [ ...content, <DisabledNotice addon="Zapier Automation" hasTitle={true} /> ]; }
    return content;
} );

// Multiple Currency Disabled Notice :
removeFilter('wp_travel_settings_tab_misc_multiple_currency', 'WPTravel/Settings/Misc/Notices');
addFilter( 'wp_travel_settings_tab_misc_multiple_currency', 'WPTravel/Settings/Misc/ThirdParty/NoticeDisabled', ( content, settings ) => {
    const {modules, options} = settings;
    const { default_settings } = options;
    const { modules:defaultModules } = default_settings;
    const moduleSettings = 'undefined' !== typeof modules && Object.keys( modules ).length > 0 ? modules : defaultModules;
    
    // 
    const isActiveMultipleCurrency = 'undefined' !== typeof moduleSettings.show_wp_travel_multiple_currency && 'yes' === moduleSettings.show_wp_travel_multiple_currency.value;    
    
    if ( ! content ) { content = []; } // Fixes for legacy support. 

    if ( ! isActiveMultipleCurrency ) { content = [ ...content, <DisabledNotice addon="Multiple Currency" hasTitle={true} /> ]; }
    return content;
} );

// Mailchimp Disabled Notice :
removeFilter('wp_travel_settings_tab_misc_mailchimp', 'WPTravel/Settings/Misc/Notices');
addFilter( 'wp_travel_settings_tab_misc_mailchimp', 'WPTravel/Settings/Misc/ThirdParty/NoticeDisabled', ( content, settings ) => {
    const {modules, options} = settings;
    const { default_settings } = options;
    const { modules:defaultModules } = default_settings;
    const moduleSettings = 'undefined' !== typeof modules && Object.keys( modules ).length > 0 ? modules : defaultModules;
    
    // 
    const isActiveMailChimp        = 'undefined' !== typeof moduleSettings.show_wp_travel_mailchimp && 'yes' === moduleSettings.show_wp_travel_mailchimp.value;    
    
    if ( ! content ) { content = []; } // Fixes for legacy support. 

    if ( ! isActiveMailChimp ) { content = [ ...content, <DisabledNotice addon="Mailchimp settings" hasTitle={true} /> ]; }
    return content;
} );

addFilter( 'wp_travel_misc_addons_notices', 'wp_travel', ( content, settings ) => {
    let filtered = Object.keys( content ).filter( key => {
        switch ( key ) {
            case 'currencyExchange' :
            case 'mailchimp' :
            case 'wishlists' :
                return false;
            default:
                return true;
        }
    } ).reduce( (obj, key) => {
        obj[key] = content[key];
        return obj;
    }, {});
    return filtered
}
);

// Trip Edit Notices
// Downloads
removeFilter( 'wptravel_trip_edit_tab_content_downloads', 'WPTravel/TripEdit/DownloadsNotice' );
addFilter( 'wptravel_trip_edit_tab_content_downloads', 'WPTravel/TripEdit/DownloadsNoticeDisabled', ( content, tripData ) => {
    const {settings} = tripData;
    const {modules, options} = settings;
    const { default_settings } = options;
    const { modules:defaultModules } = default_settings;
    const moduleSettings = 'undefined' !== typeof modules && Object.keys( modules ).length > 0 ? modules : defaultModules;

    const isActive  = 'undefined' !== typeof moduleSettings.show_wp_travel_downloads && 'yes' === moduleSettings.show_wp_travel_downloads.value;
    if ( ! content ) { content = []; } // Fixes for legacy support. 
    if ( ! isActive ) { content = [ ...content, <DisabledNotice addon="Downloads" /> ]; }
    return content;
} );
/**
 * @since 5.0.0
 * trip edit notice
 * trip guide
 */
removeFilter( 'wptravel_trip_edit_tab_content_guides', 'WPTravel/TripEdit/GuideNotice' );
addFilter( 'wptravel_trip_edit_tab_content_guides', 'WPTravel/TripEdit/GuideNoticeDisabled', ( content, tripData ) => {
    const {settings} = tripData;
    const {modules, options} = settings;
    const { default_settings } = options;
    const { modules:defaultModules } = default_settings;
    const moduleSettings = 'undefined' !== typeof modules && Object.keys( modules ).length > 0 ? modules : defaultModules;
    const isActive  = 'undefined' !== typeof moduleSettings.show_wp_travel_downloads && 'yes' === moduleSettings.show_wp_travel_downloads.value;
    if ( ! content ) { content = []; } // Fixes for legacy support.
    if ( ! isActive ) { content = [ ...content, <DisabledNotice addon="Guides" /> ]; }
    return content;
} );
// Downloads Block plugin
removeFilter( 'wptravel_trip_edit_block_tab_downloads', 'WPTravel/TripEdit/Block/Downloads/DownloadsFields'  );
addFilter( 'wptravel_trip_edit_block_tab_downloads', 'WPTravel/TripEdit/Block/Downloads/DownloadsFieldsDisabled', ( content, tripData ) => {
    const {settings} = tripData;
    const {modules, options} = settings;
    const { default_settings } = options;
    const { modules:defaultModules } = default_settings;
    const moduleSettings = 'undefined' !== typeof modules && Object.keys( modules ).length > 0 ? modules : defaultModules;
    const isActive  = 'undefined' !== typeof moduleSettings.show_wp_travel_downloads && 'yes' === moduleSettings.show_wp_travel_downloads.value;
    if ( ! content ) { content = []; } // Fixes for legacy support. 
    if ( ! isActive ) { content = [ ...content, <DisabledNotice addon="Downloads" /> ]; }
    return content;
} );

// Inventory
removeFilter( 'wptravel_trip_edit_tab_content_inventory_options', 'WPTravel/TripEdit/InventoryNotice' );
addFilter( 'wptravel_trip_edit_tab_content_inventory_options', 'WPTravel/TripEdit/InventoryNoticeDisabled', ( content, tripData ) => {
    const {settings} = tripData;
    const {modules, options} = settings;
    const { default_settings } = options;
    const { modules:defaultModules } = default_settings;
    const moduleSettings = 'undefined' !== typeof modules && Object.keys( modules ).length > 0 ? modules : defaultModules;
    const isActive  = 'undefined' !== typeof moduleSettings.show_wp_travel_inventory_management && 'yes' === moduleSettings.show_wp_travel_inventory_management.value;
    if ( ! content ) { content = []; } // Fixes for legacy support. 
    if ( ! isActive ) { content = [ ...content, <DisabledNotice addon="Inventory" /> ]; }
    return content;
} );

// Price 
removeFilter('wp_travel_after_pricings_options', 'WPTravel/TripEdit/PriceDates/MorePricingNotice' );
// addFilter( 'wp_travel_after_pricings_options', 'WPTravel/TripEdit/PriceDates/MorePricingNoticeDisabled', ( content, tripData ) => {
//     const {settings} = tripData;
//     const {modules, options} = settings;
//     const { default_settings } = options;
//     const { modules:defaultModules } = default_settings;
//     const moduleSettings = 'undefined' !== typeof modules && Object.keys( modules ).length > 0 ? modules : defaultModules;
//     const isActive  = 'undefined' !== typeof moduleSettings.show_wp_travel_utilities && 'yes' === moduleSettings.show_wp_travel_utilities.value;
//     if ( ! content ) { content = []; } // Fixes for legacy support. 
//     if ( ! isActive ) { content = [ ...content, <DisabledNotice addon="Utilities" /> ]; }
//     return content;
// } );
// Date.
removeFilter( 'wp_travel_after_dates_options', 'WPTravel/TripEdit/PriceDates/MoreDatesNotice' );
// addFilter( 'wp_travel_after_dates_options', 'WPTravel/TripEdit/PriceDates/MoreDatesNoticeDisabled', ( content, tripData ) => {
//     const {settings} = tripData;
//     const {modules, options} = settings;
//     const { default_settings } = options;
//     const { modules:defaultModules } = default_settings;
//     const moduleSettings = 'undefined' !== typeof modules && Object.keys( modules ).length > 0 ? modules : defaultModules;
//     const isActive  = 'undefined' !== typeof moduleSettings.show_wp_travel_utilities && 'yes' === moduleSettings.show_wp_travel_utilities.value;
//     if ( ! content ) { content = []; } // Fixes for legacy support. 
//     if ( ! isActive ) { content = [ ...content, <DisabledNotice addon="Utilities" /> ]; }
//     return content;
// } );


// Checkout.
removeFilter( 'wptravel_trip_edit_tab_content_cart_checkout', 'WPTravel/TripEdit/CheckoutNotice' );
addFilter( 'wptravel_trip_edit_tab_content_cart_checkout', 'WPTravel/TripEdit/CheckoutNoticeDisabled', ( content, tripData ) => {
    const {settings} = tripData;
    const {modules, options} = settings;
    const { default_settings } = options;
    const { modules:defaultModules } = default_settings;
    const moduleSettings = 'undefined' !== typeof modules && Object.keys( modules ).length > 0 ? modules : defaultModules;
    const isActive  = 'undefined' !== typeof moduleSettings.show_wp_travel_utilities && 'yes' === moduleSettings.show_wp_travel_utilities.value;
    if ( ! content ) { content = []; } // Fixes for legacy support. 
    if ( ! isActive ) { content = [ ...content, <DisabledNotice addon="Utilities" /> ]; }
    return content;
} );

// Faqs.
removeFilter( 'wptravel_trip_edit_tab_content_faqs', 'WPTravel/TripEdit/FaqsNotice' );
removeFilter( 'wptravel_trip_edit_block_tab_faq', 'WPTravel/TripEdit/Block/FAQ/FaqsNotice' );

// Tabs.
removeFilter( 'wptravel_trip_edit_tab_content_tabs', 'WPTravel/TripEdit/TripTabsNotice' );
removeFilter( 'wptravel_trip_edit_block_tab_inspector_controls', 'WPTravel/TripEdit/Block/Tab/InspectorControls/TripTabsNotice' );